import * as Sentry from "@sentry/react";

function scrubUrl(urlString: string): string {
	try {
		const url = new URL(urlString, window.location.origin);
		let changed = false;
		if (url.searchParams.has("token")) {
			url.searchParams.set("token", "***");
			changed = true;
		}
		if (url.searchParams.has("email")) {
			url.searchParams.set("email", "***");
			changed = true;
		}
		return changed ? (urlString.startsWith("/") ? `${url.pathname}${url.search}` : url.toString()) : urlString;
	} catch {
		return urlString;
	}
}

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	environment: import.meta.env.MODE,
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
	tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0.1),
	replaysSessionSampleRate: Number(
		import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? 0.05,
	),
	replaysOnErrorSampleRate: 1.0,
	beforeSend(event) {
		if (event.request?.url) {
			event.request.url = scrubUrl(event.request.url);
		}
		if (event.breadcrumbs) {
			event.breadcrumbs.forEach((crumb) => {
				if (crumb.data && typeof crumb.data.url === "string") {
					crumb.data.url = scrubUrl(crumb.data.url);
				}
				if (crumb.data && typeof crumb.data.to === "string") {
					crumb.data.to = scrubUrl(crumb.data.to);
				}
				if (crumb.data && typeof crumb.data.from === "string") {
					crumb.data.from = scrubUrl(crumb.data.from);
				}
			});
		}
		return event;
	},
});
